/**
 * Named debounce durations for keystroke-driven async work.
 *
 * The code base previously used five distinct hardcoded values
 * (100, 300, 500, 1000, 1500 ms) without explanation — making it hard
 * to know whether a difference was intentional or accidental.
 *
 * Pick the named constant that matches your *intent*, not just a number
 * close to what the audit picked. The "why" behind each value:
 */
export const INPUT_DEBOUNCE = {
  /** "Tick" — flush pending UI state, no API call. Use for visual-only
   *  reactions that need to wait one render cycle. */
  TICK: 100,

  /** "Short" — keystroke-fast validation. Use when the validation result
   *  is purely local (regex check, length check, lookup against an
   *  already-loaded list). Feels responsive. */
  SHORT: 300,

  /** "Medium" — debounced async validation against a network API.
   *  Balances responsiveness against API load. Most common choice. */
  MEDIUM: 500,

  /** "Long" — heavy async work (FX quote, pending-bill lookup) where the
   *  cost of a wasted request is high and the user is typing a multi-digit
   *  number (paybill, account number). */
  LONG: 1000,

  /** "Verify" — long enough that the user has *stopped* typing. Use for
   *  expensive validation that should not re-run mid-typing. */
  VERIFY: 1500,
} as const;
